"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.GanymedeColony = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var SpaceName_1 = require("../../SpaceName");
var SpaceType_1 = require("../../SpaceType");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var CardRenderDynamicVictoryPoints_1 = require("../render/CardRenderDynamicVictoryPoints");
var GanymedeColony = (function (_super) {
    __extends(GanymedeColony, _super);
    function GanymedeColony() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.GANYMEDE_COLONY,
            tags: [Tags_1.Tags.JOVIAN, Tags_1.Tags.SPACE, Tags_1.Tags.CITY],
            cost: 20,
            metadata: {
                description: 'Place a city tile ON THE RESERVED AREA.',
                cardNumber: '081',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.city().asterix().br;
                    b.vpText('1 VP per Jovian tag you have.');
                }),
                victoryPoints: CardRenderDynamicVictoryPoints_1.CardRenderDynamicVictoryPoints.jovians(1, 1),
            },
        }) || this;
    }
    GanymedeColony.prototype.getVictoryPoints = function (player) {
        return player.getTagCount(Tags_1.Tags.JOVIAN, false, false);
    };
    GanymedeColony.prototype.play = function (player) {
        player.game.addCityTile(player, SpaceName_1.SpaceName.GANYMEDE_COLONY, SpaceType_1.SpaceType.COLONY);
        return undefined;
    };
    return GanymedeColony;
}(Card_1.Card));
exports.GanymedeColony = GanymedeColony;
//# sourceMappingURL=GanymedeColony.js.map